let targets = document.querySelectorAll('.brand-fadein');

window.addEventListener('scroll', function() {
  for (var i = 0; i < targets.length; i++) {
    var offset = targets[i].getBoundingClientRect().top;
    if (offset < (window.innerHeight) * 0 / 100) { // 80%に変更
      targets[i].classList.add("brand-scroll-in");
    }
  }
});